/**
 * Web component: Grid teaser (grid-teaser)
 * -----------------------------------------------------------------------------
 * Grid teaser blocks with scheduled displays and copyable promo code.
 *
 */
/* eslint no-unused-vars: ['error', { 'argsIgnorePattern': 'component' }] */
import './grid-teaser.scss';

import { vueReady } from '~/core/runners';

import classes from '~/config/classes';
import { dateTime } from '~/helpers/general';
import { handleCopy, updateTeasers } from '~/helpers/teasers';

/**
 * DOM selectors.
 */
const selectors = {
  copyButton: '[js-grid-teaser="copyButton"]',
  // fallback currently not used for grid-teasers
  fallback: '[js-grid-teaser="fallback"]',
  teaser: '[js-grid-teaser="teaser"]',
  tooltip: '[js-grid-teaser="tooltip"]',
  promoText: '[js-grid-teaser="promoText"]',
};

/**
 * Create new <grid-teaser> custom element.
 */
class GridTeaser extends HTMLElement {
  data(component) {
    return {
      selectors: {
        teasers: [...component.querySelectorAll(selectors.teaser)],
        promoTexts: component.querySelectorAll(selectors.promoText),
        copyButtons: component.querySelectorAll(selectors.copyButton),
      },
    };
  }

  /**
   * Component lifecycle - before mount.
   */
  constructor() {
    super();
    this.$data = this.data(this);
    this.teasersUpdated = false;

    // for initial load, read campaign state from local storage and update
    // teasers if necessary
    const { copyButtons } = this.$data.selectors;
    if (copyButtons) {
      const discountCampaigns = JSON.parse(
        localStorage.getItem('discount-campaigns'),
      );
      updateTeasers.call(this, discountCampaigns, selectors);

      // listen to campaign changes, update teaser content
      cnvs.EventBus.listen('discount-campaign', (campaigns) => {
        updateTeasers.call(this, campaigns, selectors);
      });
    }
  }

  /**
   * Component lifecycle - mounted.
   */
  connectedCallback() {
    this.$data = Object.keys(this.$data).length ? this.$data : this.data(this);
    this.addEventListener('click', (event) =>
      handleCopy(event, selectors.tooltip),
    );
    let count = 0;

    /**
     * Go through each teaser and display if valid and end loop.
     */
    for (const teaser of this.$data.selectors.teasers) {
      const result = dateTime(teaser.dataset.start, teaser.dataset.end);

      if (!result || count >= 4) {
        teaser.classList.add(classes.hidden);
        teaser.classList.remove(classes.visible);
        continue;
      }

      count++;
      teaser.classList.add(classes.visible);
      teaser.classList.remove(classes.hidden);
    }
  }
}

/**
 * Define web component on Vue initialisation.
 */
vueReady(() => {
  if (customElements.get('grid-teaser')) {
    return;
  }

  customElements.define('grid-teaser', GridTeaser);
});
